<div class="flex">
  <div
    class="mx-auto grid grid-cols-3 justify-items-center place-self-center bg-[var(--faculty-200,platform-200)] text-black rounded-full px-4 py-1 select-none shadow-inner"
  >
    <button
      (click)="currentNumberChange.emit(state() - 1)"
      [disabled]="!canDecrease()"
      [ngClass]="
        canDecrease()
          ? 'cursor-pointer text-[var(--faculty-600,platform-600)] hover:text-[var(--faculty-800,platform-800)] transition'
          : 'text-[var(--faculty-400,platform-400)]'
      "
      class="w-10 h-full py-1.5 text-2xl font-semibold"
    >
      −
    </button>
    <div class="w-10 my-1.5 text-center text-2xl font-semibold text-[var(--faculty-600,platform-600)]">
      {{ internalDisplayNumber() }}
    </div>
    <button
      (click)="currentNumberChange.emit(state() + 1)"
      [disabled]="!canIncrease()"
      [ngClass]="
        canIncrease()
          ? 'cursor-pointer text-[var(--faculty-600,platform-600)] hover:text-[var(--faculty-800,platform-800)] transition'
          : 'text-[var(--faculty-400,platform-400)]'
      "
      class="w-10 h-full py-1.5 text-2xl font-semibold"
    >
      +
    </button>
  </div>
</div>
